module.exports = __webpack_public_path__ + "static/media/title.1ca50d35.png";